export default __webpack_public_path__ + "static/media/about_us_img1.5b270ead.png";